<template>
    <div>
        <Modal v-model="show"
            :width="1300"
            :footer-hide="true"
            title="定单明细"
            draggable
            @on-visible-change="onShowChange">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">
                    <Col span="24">
                    <Form label-position="top"
                        class="form-input-no-outline">
                        <Row :gutter="16">
                            <Col span="4">
                            <FormItem label="定单编号">
                                <Input :value="orderRecord.preSaleOrderRecordCode"
                                    readonly></Input>
                            </FormItem>
                            </Col>
							<Col span="4">
							<FormItem label="发货日期">
                                <Input :value="formatDateString(orderRecord.preSaleOrderRecordSendProductDate)" readonly></Input>
							</FormItem>
							</Col>
                            <Col span="4">
                            <FormItem label="下单时间">
                                <Input :value="formatDateTimeString(orderRecord.preSaleOrderRecordCreateAt)"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="定单状态">
                                <Input :value="orderRecord.preSaleOrderRecordOrderStatus"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="3">
                            <FormItem label="客户名称">
                                <Input :value="orderRecord.deliveryAddressContacts"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="3">
                            <FormItem label="联系电话">
                                <Input :value="orderRecord.deliveryAddressPhone"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="5">
                            <FormItem label="收货地址">
                                <Input :value="orderRecord.deliveryAddressFull"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                        </Row>

                        <Row :gutter="16">
                            <Col span="2">
                            <FormItem label="总件数">
                                <Input :value="orderRecord.preSaleOrderRecordTotalPieces"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="总体积">
                                <Input :value="orderRecord.preSaleOrderRecordTotalVolume"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="总配送费">
                                <Input :value="orderRecord.preSaleOrderRecordStationDeliveryFee"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="总包装费">
                                <Input :value="orderRecord.preSaleOrderRecordTotalPackageFee"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                        </Row>

                        <Row :gutter="16">
                            <Col span="24">
                            <FormItem>
                                <div slot="label"><b>定单商品</b>
                                </div>
                                <Table ref="mainTable"
                                    size="small"
                                    :columns="orderDetail.columns"
                                    :data="orderDetail.rows"
                                    stripe
                                    border />
                            </FormItem>
                            </Col>
                        </Row>
                    </Form>
                    </Col>
                </Row>
            </Card>
        </Modal>
        <PreSaleOrderDelivery ref="preSaleOrderDeliveryModal" />
        <PreSaleOrderDetail v-if="orderRecord.preSaleOrderRecordCodeOld"
            ref="preSaleOrderDetail" />
    </div>
</template>

<script>
import { formatDateTimeString, formatDateString } from '@/libs/logic';
import CurrencyInput from '@/components/number-input/currency-input';
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
import { dateRender, dateTimeRender } from '@/libs/tableRowTimeRender';

import {
    pageInit4PreSaleOrderDetail,
    printPreSaleOrderDetail
} from '@/api/modules/preSale-management/preSale-order';
import { ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID } from '@/view/preSale-management/preSale-order/PreSaleOrderStatus';
import PreSaleOrderDelivery from './preSale-order-delivery';
import { FILE_SERVER } from '@/api/modules/files';
export default {
    name: 'PreSaleOrderDetail',
    components: {
        CurrencyInput,
        DecimalInput,
        IntegerInput,
        PreSaleOrderDelivery
    },
    data() {
        return {
            show: false,
            innerSpin: false,
            orderUuid: '',
            preSaleOrderRecordUuid: '',
            pageLoading: false,
            orderRecord: {},
            orderDetail: {
                columns: [
                    { title: '序号', type: 'index', width: 40, align: 'center' },
                    { title: '苗场', key: 'seedFarmName', width: 100, align: 'center' },
                    { title: '产品编码', key: 'preSaleOrderDetailProductCode', width: 100, align: 'center' },
                    { title: '产品名称', key: 'preSaleOrderDetailProductName', align: 'center' },
                    { title: '产品形态', key: 'productForm', align: 'center' },
                    { title: '品牌', key: 'brandName', align: 'center' },
                    { title: '单位', key: 'preSaleOrderDetailProductUnit', width: 60, align: 'center' },
                    { title: '单价', key: 'preSaleOrderDetailProductDisplayPrice', width: 60, align: 'center' },
                    { title: '数量', key: 'preSaleOrderDetailOrderQuantity', width: 80, align: 'center' },
                    { title: '金额', key: 'preSaleOrderDetailTotalDisplayMoney', align: 'center' },
                    /* { title: '确认单价', key: 'preSaleOrderDetailProductPriceActual', width: 60, align: 'center' },
                    { title: '确认数量', key: 'preSaleOrderDetailOrderQuantityActual', align: 'center' },
                    { title: '确认金额', key: 'preSaleOrderDetailTotalMoneyActual', align: 'center' }, */
                    { title: '发货日期', key: 'preSaleOrderDetailSendProductDate', align: 'center', render: (h, params) => dateRender(h, params.row.preSaleOrderDetailSendProductDate) }
                    // { title: '备货数量', key: 'preSaleOrderDetailPhysicalPreparationQuantity', align: 'right' },
                    // { title: '纸箱单价', key: 'preSaleOrderDetailPackagePrice', align: 'right' },
                    // { title: '纸箱费用', key: 'preSaleOrderDetailPackageTotalMoney', align: 'right' },
                    // { title: '纸箱体积', key: 'preSaleOrderDetailPackageVolume', align: 'right' },
                    // { title: '总体积', key: 'preSaleOrderDetailPackageTotalVolume', align: 'right' },
                    /* { title: '苗场状态', key: 'preSaleOrderDetailDeliveryType', align: 'center' },
                    { title: '苗场发货量', key: 'preSaleOrderDetailDeliveryQuantity', align: 'center' },
                    { title: '转运站状态', key: 'preSaleOrderDetailStationDeliveryType', align: 'center' },
                    { title: '配送时间', key: 'preSaleOrderDetailStationDeliveryDate', align: 'center', render: (h, params) => dateRender(h, params.row.preSaleOrderDetailStationDeliveryDate) },
                    { title: '配送发货量', key: 'preSaleOrderDetailCustomerReceiveQuantity', align: 'center' } */
                    // { title: '缓冲天数', key: 'preSaleOrderDetailDeliveryDayBuffer', width: 60, align: 'center' },
                    // { title: '缓冲货量', key: 'preSaleOrderDetailDeliveryQuantityBuffer', width: 60, align: 'center' }
                ],
                rows: []
            }
        };
    },
    computed: {
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(orderUuid) {
            this.orderUuid = orderUuid;
            this.show = true;
        },
        formatDateTimeString,
        formatDateString,
        init() {
            // const query = this.$route.query;
            if (this.orderUuid) {
                this.preSaleOrderRecordUuid = this.orderUuid;

                this.innerSpin = true;
                pageInit4PreSaleOrderDetail(this.orderUuid).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.orderRecord = res.data.orderDetail.orderRecord;
                        this.orderDetail.rows = res.data.orderDetail.orderDetail;

                        let forwardDeliveryList = res.data.forwardDelivery.records;
                        let forwardDeliveryRemark = '';
                        forwardDeliveryList.forEach(e => {
                            if (e.preSaleForwardDeliveryRecordRemark !== '') {
                                forwardDeliveryRemark += `【${formatDateTimeString(e.preSaleForwardDeliveryRecordCreateAt)}】:${e.preSaleForwardDeliveryRecordRemark}`;
                            }
                        });

                        this.orderRecord.preSaleOrderRecordRemark += forwardDeliveryRemark;
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        },
        onOldOrderInfo() {
            this.$refs.preSaleOrderDetail.showModal(this.orderRecord.preSaleOrderRecordUuidOld);
            // this.orderUuid = this.orderRecord.preSaleOrderRecordUuidOld;
            // this.init();
        },
        printOrder() {
            this.innerSpin = true;
            printPreSaleOrderDetail({ preSaleOrderRecordUuid: this.orderUuid }).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    window.open(FILE_SERVER + res.data.url, "_blank");
                }
            });
        }
    }
};
</script>

<style scoped>
</style>
